import { type ComponentType } from 'react';
import type { ModuleId } from '@mentimeter/http-clients';
import { BigPresentation } from './slide-types/big/BigPresentation';
import { BulletsPresentation } from './slide-types/bullets/BulletsPresentation';
import { ChoicesPresentationDataHandler } from './slide-types/choices/ChoicesPresentationDataHandler';
import { DeprecatedPresentation } from './slide-types/deprecated/DeprecatedPresentation';
import { DocumentPresentation } from './slide-types/document/DocumentPresentation';
import { GoogleSlidesPresentation } from './slide-types/google-slides/GoogleSlidesPresentation';
import { HeadingPresentation } from './slide-types/heading/HeadingPresentation';
import { ImagePresentation } from './slide-types/image/ImagePresentation';
import { InstructionsPresentation } from './slide-types/instructions/InstructionsPresentation';
import { MetadataPresentation } from './slide-types/metadata/MetadataPresentation';
import { MiroPresentation } from './slide-types/miro/MiroPresentation';
import { NumberPresentation } from './slide-types/number/NumberPresentation';
import { NumericalQuestionPresentationDataHandler } from './slide-types/numerical-question/NumericalQuestionPresentationDataHandler';
import { OpenPresentation } from './slide-types/open/OpenPresentation';
import { ParagraphPresentation } from './slide-types/paragraph/ParagraphPresentation';
import { PinOnImagePresentationDataHandler } from './slide-types/pin-on-image/PinOnImagePresentationDataHandler';
import { PowerpointPresentation } from './slide-types/powerpoint/PowerpointPresentation';
import { QfaPresentation } from './slide-types/qfa/QfaPresentation';
import { QuizChoicesPresentationDataHandler } from './slide-types/quiz-choices/QuizChoicesPresentationDataHandler';
import { QuizLeaderboardPresentationDataHandler } from './slide-types/quiz-leaderboard/QuizLeaderboardPresentationDataHandler';
import { QuotePresentation } from './slide-types/quote/QuotePresentation';
import { RatingPresentation } from './slide-types/rating/RatingPresentation';
import { VideoPresentation } from './slide-types/video/VideoPresentation';
import { QuizOpenPresentationDataHandler } from './slide-types/quiz-open/QuizOpenPresentationDataHandler';
import { PrioritisationPresentationDataHandler } from './slide-types/100-points/PrioritisationPresentationDataHandler';
import { FreeTextPresentationDataHandler } from './slide-types/free-text/FreeTextPresentationDataHandler';
import { WordCloudPresentationDataHandler } from './slide-types/wordcloud/WordCloudPresentationDataHandler';
import { ScalesPresentationDataHandler } from './slide-types/scales/ScalesPresentationDataHandler';
import { RankingPresentationDataHandler } from './slide-types/ranking/RankingPresentationDataHandler';

const MODULE_IMPORT_MAP = {
  '100-points': PrioritisationPresentationDataHandler,
  big: BigPresentation,
  bullets: BulletsPresentation,
  choices: ChoicesPresentationDataHandler,
  deprecated: DeprecatedPresentation,
  document: DocumentPresentation,
  'free-text': FreeTextPresentationDataHandler,
  'google-slides': GoogleSlidesPresentation,
  heading: HeadingPresentation,
  image: ImagePresentation,
  instructions: InstructionsPresentation,
  metadata: MetadataPresentation,
  miro: MiroPresentation,
  number: NumberPresentation,
  'numerical-question': NumericalQuestionPresentationDataHandler,
  open: OpenPresentation,
  paragraph: ParagraphPresentation,
  'pin-on-image': PinOnImagePresentationDataHandler,
  powerpoint: PowerpointPresentation,
  qfa: QfaPresentation,
  'quiz-choices': QuizChoicesPresentationDataHandler,
  'quiz-leaderboard': QuizLeaderboardPresentationDataHandler,
  'quiz-open': QuizOpenPresentationDataHandler,
  quote: QuotePresentation,
  ranking: RankingPresentationDataHandler,
  rating: RatingPresentation,
  scales: ScalesPresentationDataHandler,
  video: VideoPresentation,
  wordcloud: WordCloudPresentationDataHandler,
} satisfies Record<ModuleId, ComponentType>;

export const getPresentationModuleById = (moduleId: ModuleId) => {
  return MODULE_IMPORT_MAP[moduleId] ?? DeprecatedPresentation;
};
